import React from 'react'

interface LabeledValueProps {
  value: any
  label: string
  valueStyles?: string
  labelStyles?: string
}

const LabeledValue = (props: LabeledValueProps) => {
  const {label, value, valueStyles, labelStyles} = props
  const valueClassNames = valueStyles ? valueStyles : 'text-md'
  const labelClassNames = labelStyles
    ? labelStyles
    : 'text-xs leading-none text-gray-400'
  return (
    <div className="labeled-value flex flex-col align-start mb-2">
      <div className={valueClassNames}>{value}</div>
      <span className={labelClassNames}>{label}</span>
    </div>
  )
}

export default LabeledValue
